import { ContentItem } from '../types'
import { Text } from '@crossfit/design-system'
import style from './style.module.scss'
import { Button, Icon } from '@crossfit/ui'

export default function ContentCard({ item }: { item: ContentItem }) {
  return (
    <a
      href={item.link?.url}
      target='_blank'
      className={style.link}
      rel='noreferrer'
    >
      <div className={style.container}>
        <div className={style.left}>
          <div className={style.headerContainer}>
            <Text type='body' size='md' bold className={style.headline}>
              {item.headlineText}
            </Text>
            <Text type='body' size='sm' className={style.bodyText}>
              {item.bodyText}
            </Text>
          </div>
          <Button rightIcon={<Icon name='arrow-right' />} variant='tertiary'>
            {item.link?.text}
          </Button>
        </div>
        <div className={style.right}>
          <img src={item.image?.sizes?.thumbnail} className={style.image} />
        </div>
      </div>
    </a>
  )
}
